import { fetchData } from "@client";

export async function getXlsImportConfigsQuery() {
  const res = await fetchData("/xls-configs");
  return res.results;
}
